import jwtAxios from '@tenant/services/auth/jwt-auth';

export const APP_INSTANCE_APIS = {
  ROOT: 'api/idp-clients',
};

export const getListIDPClientQuery = (params) => {
  return jwtAxios.get(APP_INSTANCE_APIS.ROOT, { params });
};

export const getListIDPClientFlowQuery = (params) => {
  return jwtAxios.get(`${APP_INSTANCE_APIS.ROOT}/idp-client-flows`, { params });
};

export const getDetailIDPClientQuery = (id) => {
  return jwtAxios.get(APP_INSTANCE_APIS.ROOT + '/' + id);
};

export const deleteIDPClientQuery = (payload) => {
  return jwtAxios.delete(APP_INSTANCE_APIS.ROOT + '/' + payload?.Id);
};

export const addClientsByAppInstance = ({ ...payload }) => {
  return jwtAxios.post(APP_INSTANCE_APIS.ROOT, payload);
};

export const updateClientsByAppInstance = ({
  idpClientId,
  ...payload
}) => {
  return jwtAxios.patch(
    APP_INSTANCE_APIS.ROOT + '/' + idpClientId,
    payload,
  );
};
